<template lang="pug">
    //- div(v-if="validHourlyDashboardSummaries && validDayDashboardSummary")
    //-     v-card.ma-4(
    //-         elevation='0'
    //-         shaped
    //-         style="border: 1px solid var(--volie-teal)"
    //-     )
    //-         v-card-text
    //-             line-chart(:data="chartData")
    div.d-flex.align-center.justify-center.pa-4(v-if="teamScopeEmptyMessage")
        v-alert(type="info" dense outlined style="width: 100%;")
            | {{ teamScopeEmptyMessage }}

    div(v-else-if="validDayDashboardSummary")
        v-card.ma-4(
            elevation='0'
            shaped
            style="border: 1px solid var(--volie-teal)"
        )
            v-toolbar(
                color="var(--volie-teal)"
                dark
                dense
            )
                v-toolbar-title Inbound

            v-card-text
                template
                    v-list(two-line)
                        template
                            v-list-item
                                v-list-item-icon
                                    v-icon(color='primary')
                                        | mdi-phone-incoming
                                v-list-item-content
                                    v-list-item-title {{ currentDayDashboardSummary.phone_inbound_call_count | number }}
                                    v-list-item-subtitle Calls
                            v-list-item
                                v-list-item-icon
                                v-list-item-content
                                    v-list-item-title {{ currentDayDashboardSummary.phone_call_transfer_count | number }}
                                    v-list-item-subtitle Transfers
                            v-list-item
                                v-list-item-icon
                                v-list-item-content
                                    v-list-item-title {{ currentDayDashboardSummary.phone_calls_ignored_count | number }}
                                    v-list-item-subtitle Ignores

                            template
                                v-divider(inset)
                                v-list-item
                                    v-list-item-icon
                                        v-icon(color='primary')
                                            | mdi-phone-missed
                                    v-list-item-content
                                        v-list-item-title {{ (agentDropPercentage || 0).toFixed(2) | number }}%
                                        v-list-item-subtitle Agent Drop %
                            v-list-item
                                v-list-item-icon
                                v-list-item-content
                                    v-list-item-title {{ (completedAgentDropPercentage || 0).toFixed(2) | number }}%
                                    v-list-item-subtitle Returned Agent Drop Call %
                            v-list-item
                                v-list-item-icon
                                v-list-item-content
                                    v-list-item-title {{ (adjustedAgentDropPercentage || 0).toFixed(2) | number }}%
                                    v-list-item-subtitle Adjusted Agent Drop %
                            v-list-item
                                v-list-item-icon
                                v-list-item-content
                                    v-list-item-title {{ currentDayDashboardSummary.phone_missed_call_agent_dropped_contact_count | number }} ({{ (contactAgentDropPercentage || 0).toFixed(2) | number }}% of returned)
                                    v-list-item-subtitle Contacts returning agent drops %
                            v-list-item
                                v-list-item-icon
                                v-list-item-content
                                    v-list-item-title {{ currentDayDashboardSummary.phone_missed_call_agent_dropped_appointment_count | number }} ({{ (appointmentAgentDropPercentage || 0).toFixed(2) | number }}% of returned)
                                    v-list-item-subtitle Appts set returning agent drops %

                            template
                                v-divider(inset)
                                v-list-item
                                    v-list-item-icon
                                        v-icon(color='primary')
                                            | mdi-voicemail
                                    v-list-item-content
                                        v-list-item-title {{ (voicemailPercentage || 0).toFixed(2) | number }}%
                                        v-list-item-subtitle Voicemail %
                            v-list-item
                                v-list-item-icon
                                v-list-item-content
                                    v-list-item-title {{ (completedVoicemailPercentage || 0).toFixed(2) | number }}%
                                    v-list-item-subtitle Returned Voicemail %
                            v-list-item
                                v-list-item-icon
                                v-list-item-content
                                    v-list-item-title {{ currentDayDashboardSummary.phone_missed_call_voice_mail_contact_count | number }} ({{ (contactVoicemailPercentage || 0).toFixed(2) | number }}% of returned)
                                    v-list-item-subtitle Contacts returning voicemails %
                            v-list-item
                                v-list-item-icon
                                v-list-item-content
                                    v-list-item-title {{ currentDayDashboardSummary.phone_missed_call_voice_mail_appointment_count | number }} ({{ (appointmentVoicemailPercentage || 0).toFixed(2) | number }}% of returned)
                                    v-list-item-subtitle Appts set returning voicemails %

        v-card.ma-4(
            elevation='0'
            shaped
            style="border: 1px solid var(--volie-teal)"
        )
            v-toolbar(
                color="var(--volie-teal)"
                dark
                dense
            )
                v-toolbar-title Outbound

            v-card-text
                template
                    v-list(two-line)
                        template
                            v-list-item
                                v-list-item-icon
                                    v-icon(color='primary')
                                        | mdi-phone-outgoing
                                v-list-item-content
                                    v-list-item-title {{ currentDayDashboardSummary.phone_outbound_call_count | number }}
                                    v-list-item-subtitle Calls
                            v-list-item
                                v-list-item-icon
                                v-list-item-content
                                    v-list-item-title {{ currentDayDashboardSummary.phone_calls_skipped_count | number }}
                                    v-list-item-subtitle Skips
                            v-list-item
                                v-list-item-icon
                                v-list-item-content
                                    v-list-item-title {{ currentDayDashboardSummary.phone_suspicious_call_count | number }}
                                    v-list-item-subtitle Suspicious
</template>

<script lang="ts">
    import Vue from 'vue';
    import Chartkick from 'vue-chartkick';
    import Chart from 'chart.js';
    Vue.use(Chartkick.use(Chart));

    import { adjustedAgentDropRate, agentDropRate } from '@/helpers/dashboard_summary';

    export default Vue.extend({
        data() {
            return {
                isLoading: false,
            }
        },
        methods: {
            calculatePercentage(x, y) {
                if (!x || !y) {
                    return 0;
                }
                return (x / y) * 100.0;
            },
            calculateAdjustedAgentDropPercentage(summary) {
                return adjustedAgentDropRate(summary);
            },
            calculateAdjustedVoicemailPercentage(summary) {
                return summary?.phone_missed_call_voice_mail_count > 0 && summary?.phone_inbound_call_count > 0 ? this.calculatePercentage(summary.phone_missed_call_voice_mail_count - (summary?.phone_missed_call_voice_mail_contact_count || 0), summary.phone_inbound_call_count) : 0;
            },
        },
        computed: {
            agentDropPercentage() {
                return agentDropRate(this.currentDayDashboardSummary);
            },
            appointmentAgentDropPercentage() {
                return this.currentDayDashboardSummary?.phone_missed_call_agent_dropped_appointment_count > 0 && this.currentDayDashboardSummary?.phone_missed_call_agent_dropped_completed_count > 0 ? this.calculatePercentage(this.currentDayDashboardSummary.phone_missed_call_agent_dropped_appointment_count, this.currentDayDashboardSummary.phone_missed_call_agent_dropped_completed_count) : 0;
            },
            chartData() {

                // Init
                const sl = {
                    name: "Service Level",
                    data: {
                        '6am': null,
                        '7am': null,
                        '8am': null,
                        '9am': null,
                        '10am': null,
                        '11am': null,
                        '12pm': null,
                        '1pm': null,
                        '2pm': null,
                        '3pm': null,
                        '4pm': null,
                        '5pm': null,
                        '6pm': null,
                        '7pm': null,
                        '8pm': null,
                        '9pm': null,
                        '10pm': null,
                        '11pm': null,
                    }
                }

                const inbound = {
                    name: "IB Calls",
                    data: {
                        '6am': null,
                        '7am': null,
                        '8am': null,
                        '9am': null,
                        '10am': null,
                        '11am': null,
                        '12pm': null,
                        '1pm': null,
                        '2pm': null,
                        '3pm': null,
                        '4pm': null,
                        '5pm': null,
                        '6pm': null,
                        '7pm': null,
                        '8pm': null,
                        '9pm': null,
                        '10pm': null,
                        '11pm': null,
                    }
                }

                const outbound = {
                    name: "OB Calls",
                    data: {
                        '6am': null,
                        '7am': null,
                        '8am': null,
                        '9am': null,
                        '10am': null,
                        '11am': null,
                        '12pm': null,
                        '1pm': null,
                        '2pm': null,
                        '3pm': null,
                        '4pm': null,
                        '5pm': null,
                        '6pm': null,
                        '7pm': null,
                        '8pm': null,
                        '9pm': null,
                        '10pm': null,
                        '11pm': null,
                    }
                }

                // Build if present
                if (this.validHourlyDashboardSummaries) {

                    // Loop over hourly summaries
                    for (let i = 0; i < this.hourlyDashboardSummaries.length; i++) {

                        // Init
                        const period = this.hourlyDashboardSummaries[i];
                        if (!period || !(period.id > 0) || period.period_type !== "hour") {
                            continue;
                        }

                        // Init date
                        const beginTime = new Date(period.begin_time);
                        if (!beginTime) {
                            continue;
                        }

                        // Init utc hours
                        const utcHours = beginTime.getUTCHours();
                        if (utcHours < 6) {
                            continue;
                        }

                        // Create sl
                        const serviceLevelCalc = 100.0 - this.calculateAdjustedAgentDropPercentage(period) - this.calculateAdjustedVoicemailPercentage(period);

                        // Init
                        let dataKey = null;

                        // Switch over hours
                        switch (utcHours) {
                        case 6:
                            dataKey = '6am';
                            break;
                        case 7:
                            dataKey = '7am';
                            break;
                        case 8:
                            dataKey = '8am';
                            break;
                        case 9:
                            dataKey = '9am';
                            break;
                        case 10:
                            dataKey = '10am';
                            break;
                        case 11:
                            dataKey = '11am';
                            break;
                        case 12:
                            dataKey = '12pm';
                            break;
                        case 13:
                            dataKey = '1pm';
                            break;
                        case 14:
                            dataKey = '2pm';
                            break;
                        case 15:
                            dataKey = '3pm';
                            break;
                        case 16:
                            dataKey = '4pm';
                            break;
                        case 17:
                            dataKey = '5pm';
                            break;
                        case 18:
                            dataKey = '6pm';
                            break;
                        case 19:
                            dataKey = '7pm';
                            break;
                        case 20:
                            dataKey = '8pm';
                            break;
                        case 21:
                            dataKey = '9pm';
                            break;
                        case 22:
                            dataKey = '10pm';
                            break;
                        case 23:
                            dataKey = '11pm';
                            break;
                        }

                        // Set
                        if (dataKey?.length > 0) {
                            sl.data[dataKey] = serviceLevelCalc;
                            inbound.data[dataKey] = period.phone_inbound_call_count;
                            outbound.data[dataKey] = period.phone_outbound_call_count;
                        }
                    }
                }

                return [
                    sl,
                    inbound,
                    outbound,
                ];
            },
            completedAgentDropPercentage() {
                return this.currentDayDashboardSummary?.phone_missed_call_agent_dropped_completed_count > 0 && this.currentDayDashboardSummary?.phone_missed_call_agent_dropped_count > 0 ? this.calculatePercentage(this.currentDayDashboardSummary.phone_missed_call_agent_dropped_completed_count, this.currentDayDashboardSummary.phone_missed_call_agent_dropped_count) : 0;
            },
            contactAgentDropPercentage() {
                return this.currentDayDashboardSummary?.phone_missed_call_agent_dropped_contact_count > 0 && this.currentDayDashboardSummary?.phone_missed_call_agent_dropped_completed_count > 0 ? this.calculatePercentage(this.currentDayDashboardSummary.phone_missed_call_agent_dropped_contact_count, this.currentDayDashboardSummary.phone_missed_call_agent_dropped_completed_count) : 0;
            },
            adjustedAgentDropPercentage() {
                return adjustedAgentDropRate(this.currentDayDashboardSummary);
            },
            voicemailPercentage() {
                return this.currentDayDashboardSummary?.phone_missed_call_voice_mail_count > 0 && this.currentDayDashboardSummary?.phone_inbound_call_count > 0 ? this.calculatePercentage(this.currentDayDashboardSummary.phone_missed_call_voice_mail_count, this.currentDayDashboardSummary.phone_inbound_call_count) : 0;
            },
            appointmentVoicemailPercentage() {
                return this.currentDayDashboardSummary?.phone_missed_call_voice_mail_appointment_count > 0 && this.currentDayDashboardSummary?.phone_missed_call_agent_dropped_completed_count > 0 ? this.calculatePercentage(this.currentDayDashboardSummary.phone_missed_call_voice_mail_appointment_count, this.currentDayDashboardSummary.phone_missed_call_voice_mail_completed_count) : 0;
            },
            completedVoicemailPercentage() {
                return this.currentDayDashboardSummary?.phone_missed_call_voice_mail_completed_count > 0 && this.currentDayDashboardSummary?.phone_missed_call_voice_mail_count > 0 ? this.calculatePercentage(this.currentDayDashboardSummary.phone_missed_call_voice_mail_completed_count, this.currentDayDashboardSummary.phone_missed_call_voice_mail_count) : 0;
            },
            contactVoicemailPercentage() {
                return this.currentDayDashboardSummary?.phone_missed_call_voice_mail_contact_count > 0 && this.currentDayDashboardSummary?.phone_missed_call_agent_dropped_completed_count > 0 ? this.calculatePercentage(this.currentDayDashboardSummary.phone_missed_call_voice_mail_contact_count, this.currentDayDashboardSummary.phone_missed_call_voice_mail_completed_count) : 0;
            },
            validDayDashboardSummary() {
                return this.currentDayDashboardSummary?.id > 0;
            },
            validHourlyDashboardSummaries() {
                return this.hourlyDashboardSummaries?.length > 0;
            },
        },
        components: {
        },
        props: {
            currentDayDashboardSummary: Object,
            hourlyDashboardSummaries: Array,
            teamScopeEmptyMessage: String,
        },
        watch: {
        },
        destroyed() {
        },
        created() {
        },
        mounted() {
        },
    });
</script>

<style lang="scss" scoped>
    #app {
        .cell-value-spacing {
            padding: 0 0 5px 0;
        }
    }
</style>